import { GetDefaultParentType, OccupantTypeOptions } from "../constants/ProConstants"

export const BuildingModel = {
      key:"",
      id:"",
      name:"",
      location: null,            
      bedCapacity:0,
      sameAsLocationAddress: false,
      isActive:true,
      address:{       
        addressLine1: "",
        addressLine2:"",
        city:"",
        state: null,
        zipCode:""
     },
     program: null,
     bedMngmtStaffDetails:null,
     note:""
}

export const NodeModel = {
    key:"",
    id:"",
    location: null, 
    building:null,
    parentType:GetDefaultParentType(),
    parent:null,
    isActive:true,
    name:"",   
    bedCapacity:0,    
    bedMngmtStaffDetails:null,
    program:null,
    note:""
}


export const BedModel = {
  key:"",
  id:"",
  location: null, 
  building:null,
  parentType:GetDefaultParentType(),
  parent:null,
  room:null,
  bedType: {},
  bedStatus:{},
  bedTags:null,
  isActive:true,
  name:"", 
  bedMngmtStaffDetails:null,
  program:null,
  note:""
}

export const ReserveOrAssignBedModel  = {
  bedId:0,
  occupantType:OccupantTypeOptions[0],
  client: null, 
  dependentName:"",
  startDate: null,
  endDate: null,
  stayDuration : 1,
  action:"",
  date:""
}

export const MoveClientModel  = { 
  location:null,
  building: null,
  parentType: null,
  parent:null,
  room: null,
  bed: null,
  date:""
}

export const CensusFilterModel = {
  date: null,
  bedMngmtStaffDetails:null,
  bedType:null,
  bedTags:null,
  program:null,
  bedStatus:null,
  occupancyStatus: null,
  reservationStatus: null,
  activeStatus: null,
  selectedLocations:null,
  lengthOfStay:null,
  pageName:"CENSUS"
}

export const AttendanceFilterModel = {
  date: null,
  bedMngmtStaffDetails:null,
  bedType:null,
  bedTags:null,
  program:null,
  bedStatus:null,
  occupancyStatus: null,
  reservationStatus: null,
  activeStatus: null,
  selectedLocations:null,
  lengthOfStay:null,
  pageName:"ATTENDANCE"
}

export const WaitlistFilterModel = {
  
}

export const WaitlistClientModel = {
  clientType:null,
  client:null,
  pendingClientName:null,
  waitlist:null,
  priority:null,
  waitlistStatus:null, 
  note:""
}


